var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRules({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.00065 3.5333V14.22C7.88732 14.22 7.76732 14.2 7.67398 14.1466L7.64732 14.1333C6.36732 13.4333 4.13398 12.7 2.68732 12.5066L2.49398 12.48C1.85398 12.4 1.33398 11.8 1.33398 11.16V3.10663C1.33398 2.3133 1.98065 1.7133 2.77398 1.77996C4.17398 1.8933 6.29398 2.59996 7.48065 3.33996L7.64732 3.43996C7.74732 3.49996 7.87398 3.5333 8.00065 3.5333Z",
    fill: "#075FCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 3.11333V11.16C14.6667 11.8 14.1467 12.4 13.5067 12.48L13.2867 12.5067C11.8333 12.7 9.59333 13.44 8.31333 14.1467C8.22667 14.2 8.12 14.22 8 14.22V3.53333C8.12667 3.53333 8.25333 3.5 8.35333 3.44L8.46667 3.36667C9.65333 2.62 11.78 1.90667 13.18 1.78667H13.22C14.0133 1.72 14.6667 2.31333 14.6667 3.11333Z",
    fill: "#075FCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16602 6.16003H3.66602C3.39268 6.16003 3.16602 5.93337 3.16602 5.66003C3.16602 5.3867 3.39268 5.16003 3.66602 5.16003H5.16602C5.43935 5.16003 5.66602 5.3867 5.66602 5.66003C5.66602 5.93337 5.43935 6.16003 5.16602 6.16003Z",
    fill: "#075FCC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66602 8.16003H3.66602C3.39268 8.16003 3.16602 7.93337 3.16602 7.66003C3.16602 7.3867 3.39268 7.16003 3.66602 7.16003H5.66602C5.93935 7.16003 6.16602 7.3867 6.16602 7.66003C6.16602 7.93337 5.93935 8.16003 5.66602 8.16003Z",
    fill: "#075FCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRules);
export default __webpack_public_path__ + "static/media/rules.568a333ee3f3feb47b17352b0d6833e0.svg";
export { ForwardRef as ReactComponent };